import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { PublishError } from 'app/typings/publishError';
import { extractMissingFields } from 'app/utils/publishError';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function usePublishHotel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ hotelId }: { hotelId: number }) => {
      return apiMutation('POST', {
        path: ENDPOINTS.publishHotel,
        params: { id: hotelId.toString() },
      }) as Promise<void>;
    },
    onSuccess: (_, { hotelId }) => {
      message.success(`Hotel #${hotelId} published`);
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.hotels],
        exact: false,
      });
    },
    onError: (error: PublishError, { hotelId }) => {
      if (extractMissingFields(error) !== null) {
        return;
      }

      message.error(`Error while publishing hotel #${hotelId}`);
    },
  });
}
